import { render, staticRenderFns } from "./exCodePopup.vue?vue&type=template&id=049f6c48&scoped=true&"
import script from "./exCodePopup.vue?vue&type=script&lang=ts&"
export * from "./exCodePopup.vue?vue&type=script&lang=ts&"
import style0 from "./exCodePopup.vue?vue&type=style&index=0&id=049f6c48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049f6c48",
  null
  
)

export default component.exports